export default function LocalIntro() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-6 md:mb-8">
            Votre réparateur de fenêtre à Illkirch-Graffenstaden
          </h2>
          <div className="space-y-5 text-plum-dark text-base md:text-lg leading-relaxed">
            <p>
              À quelques minutes de Strasbourg, Illkirch-Graffenstaden mêle campus universitaire, zones d'activité et quartiers résidentiels. Que votre fenêtre soit en PVC récent ou en aluminium, nous réparons la pièce défectueuse chez vous, déplacement gratuit.
            </p>
            <p>
              Illkirch-Graffenstaden, à la lisière de Strasbourg, est une commune en pleine expansion. Campus universitaire, technopole et zones d'activité côtoient des quartiers résidentiels variés. Les fenêtres sont majoritairement en PVC et aluminium, avec des mécanismes modernes. Nous connaissons les spécificités de chaque quartier et réparons sur place.
            </p>
            <p>
              À moins de 10 minutes de notre atelier, Illkirch bénéficie d'une réactivité exceptionnelle. Nous intervenons le jour même pour les urgences, le déplacement est gratuit, le devis est gratuit et chaque pièce est garantie 10 ans. Nos techniciens arrivent avec les pièces nécessaires pour réparer dans plus de 90 % des cas.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}